export default "__VITE_ASSET__CWU6Ygnm__"